<p-table #dt [columns]="cols" [value]="dados" [rowHover]="true" [loading]="loading" [scrollable]="true"
  scrollHeight="50vh" [autoLayout]="true"
  styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines p-datatable-responsive-demo p-shadow-3"
  sortMode="multiple" [globalFilterFields]="['codDealer']" paginatorDropdownAppendTo="body">
  <ng-template pTemplate="colgroup" let-columns>
    <colgroup *ngFor="let col of columns">
      <col [style]="col.width">
    </colgroup>
  </ng-template>

  <ng-template #message pTemplate="emptymessage" let-columns>
    <tr *ngIf="dados?.length != 0">
      <td id="message" [attr.colspan]="columns.length" class="text-center bg-no-records p-shadow-3"
        style="padding: 20px;">
        <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="2"
        class="frozenColumn">
        Todos os Tipos
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Abr / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Mai / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Jun / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Q1 / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Jul / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Ago / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Set / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Q2 / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Out / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Nov / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Dez / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Q3 / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Jan / {{totaisHistorico.filtroAno + 1}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Fev / {{totaisHistorico.filtroAno + 1}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Mar / {{totaisHistorico.filtroAno + 1}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="4">
        Q4 / {{totaisHistorico.filtroAno + 1}}
      </th>
    </tr>
    <tr>
      <ng-container *ngFor="let col of columns">
        <th [pSortableColumn]="col.field" style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
          [ngStyle]="{'width': col.width}"
          [class.frozenColumnDealer]="col.field == 'codDealer'" [class.frozenColumnNome]="col.field == 'nomeDealer'" >
          {{col.header}}
          <p-sortIcon [field]="col.field" class="p-sortable-colum"
            *ngIf="col.field !== 'selecionar' && col.field !== 'edit'">
          </p-sortIcon>
        </th>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-dados let-columns="columns">
    <tr>
      <td *ngFor="let col of columns" [class.frozenColumnInfoDealer]="col.field == 'codDealer'"
      [class.frozenColumnInfoNome]="col.field == 'nomeDealer'">
        <div *ngIf="col.field != 'visivel'">
          {{ col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer" let-dados let-columns="columns">
    <tr>
      <td class="text-center frozenColumn" style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
        colspan="2">
        Brasil
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAbrRealizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAbrObjetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAbrGap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAbrPercent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMaiRealizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMaiObjetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMaiGap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMaiPercent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJunRealizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJunObjetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJunGap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJunPercent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ1Realizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ1Objetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ1Gap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ1Percent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJulRealizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJulObjetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJulGap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJulPercent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAgoRealizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAgoObjetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAgoGap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAgoPercent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalSetRealizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalSetObjetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalSetGap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalSetPercent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ2Realizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ2Objetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ2Gap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ2Percent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalOutRealizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalOutObjetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalOutGap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalOutPercent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalNovRealizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalNovObjetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalNovGap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalNovPercent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalDezRealizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalDezObjetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalDezGap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalDezPercent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ3Realizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ3Objetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ3Gap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ3Percent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJanRealizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJanObjetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJanGap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJanPercent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalFevRealizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalFevObjetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalFevGap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalFevPercent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMarRealizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMarObjetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMarGap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMarPercent}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ4Realizado}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ4Objetivo}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ4Gap}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ4Percent}}
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="card" *ngIf="dados?.length === 0">
  <div class="card-body bg-no-records p-shadow-3">
    <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
  </div>
</div>
